import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Form, Input } from 'antd';
import React from 'react';
import InputError from 'ui/form/inputError';
import styles from './index.module.scss';

interface Props {
  label?: string;
  name?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  style?: React.CSSProperties;
  error?: string;
  id?: string;
  dataTestId?: string;
  className?: string;
  passwordHint?: React.ReactNode;
}

export default function PasswordInput({
  label,
  onChange,
  onBlur,
  style,
  error,
  id,
  dataTestId,
  className,
  passwordHint,
  name,
}: Props) {
  return (
    <Form.Item label={label}>
      <Input.Password
        className={className}
        id={id}
        name={name}
        data-test-id={dataTestId}
        onChange={onChange}
        onBlur={onBlur}
        style={style}
        iconRender={(visible) =>
          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
        }
      />
      <InputError error={error} />
      <p className={styles.passwordHint}>{passwordHint}</p>
    </Form.Item>
  );
}
